import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

const LOGMAPS_URL = 'https://logmaps.com.br';
const SUPPORT_WHATSAPP_URL = 'https://wa.me/5511941956997';
const CONTACT_EMAIL = 'contato@patrociconnect.com.br';

/** Rodapé padrão LOGMAPS — obrigatório em todas as páginas. */
export function SiteFooter({ className }: { className?: string }) {
  const linkClass =
    'rounded underline-offset-4 transition-colors hover:text-ink hover:underline focus-visible:text-ink';

  return (
    <footer className={cn('border-t border-line', className)}>
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-3 px-4 py-5 text-xs text-muted sm:flex-row sm:flex-wrap sm:justify-between sm:px-6 lg:px-8">
        <p>
          Desenvolvido por{' '}
          <a href={LOGMAPS_URL} target="_blank" rel="noopener noreferrer" className={cn(linkClass, 'font-semibold text-ink/80')}>
            LOGMAPS
          </a>
        </p>
        <nav aria-label="Links institucionais e suporte">
          <ul className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
            <li>
              <a href={SUPPORT_WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className={linkClass}>
                Suporte: WhatsApp
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT_EMAIL}`} className={linkClass}>
                {CONTACT_EMAIL}
              </a>
            </li>
            <li>
              <Link to="/novidades" className={linkClass}>
                Novidades
              </Link>
            </li>
            <li>
              <Link to="/privacidade" className={linkClass}>
                Privacidade
              </Link>
            </li>
            <li>
              <Link to="/termos" className={linkClass}>
                Termos de Uso
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
}
